export default __webpack_public_path__ + "static/media/10.3701442c.webp";